<template>
  <div id="address-add-or-edit-modal">
    <el-dialog
      :title="type === 'add' ? '添加地址' : '编辑地址'"
      v-model="showModal"
      custom-class="order-edit-address-dialog"
      @close="onModalClose"
    >
      <div class="address-modal-body">
        <el-form
          :model="addrModel"
          ref="dataForm"
          :rules="rules"
          label-width="80px"
        >
          <el-form-item label="姓名:" prop="addressee" label-width="76px">
            <el-input
              type="text"
              v-model.trim="addrModel.addressee"
              placeholder="请输入姓名"
              :maxlength="15"
            ></el-input>
          </el-form-item>

          <el-form-item label="电话:" prop="mobile_phone" label-width="76px">
            <el-input
              type="text"
              v-model.trim="addrModel.mobile_phone"
              placeholder="请填写手机号"
              :maxlength="11"
            ></el-input>
          </el-form-item>

          <el-form-item
            label="地址:"
            class="is-required pcds"
            label-width="76px"
          >
            <el-select
              v-model="addrModel.province_code"
              placeholder="省"
              @change="addrModel.city_code = ''"
            >
              <el-option
                :label="province"
                :value="parseInt(index)"
                v-for="(province, index) in pcds[86]"
                :key="index"
              ></el-option>
            </el-select>

            <el-select
              v-model="addrModel.city_code"
              placeholder="市"
              @change="addrModel.county_code = ''"
            >
              <el-option
                :label="city"
                :value="parseInt(index)"
                v-for="(city, index) in pcds[addrModel.province_code]"
                :key="index"
              ></el-option>
            </el-select>

            <el-select v-model="addrModel.county_code" placeholder="区">
              <el-option
                :label="district"
                :value="parseInt(index)"
                v-for="(district, index) in pcds[addrModel.city_code]"
                :key="index"
              ></el-option>
            </el-select>

            <transition name="scaleY">
              <div class="el-form-item__error" v-if="!pcdValid && submitted">
                请选择省市区
              </div>
            </transition>
          </el-form-item>

          <el-form-item prop="detail_address" label-width="76px">
            <el-input
              type="text"
              v-model.trim="addrModel.detail_address"
              placeholder="详细地址"
              :maxlength="50"
            ></el-input>
          </el-form-item>

          <el-form-item
            label="智能地址填写:"
            class="recognition-box"
            label-width="76px"
          >
            <el-input
              type="textarea"
              :autosize="{ minRows: 5, maxRows: 6 }"
              v-model.trim="adderssFillingContent"
              placeholder="粘贴或输入一整段地址信息，点击“智能填写”识别姓名、电话和地址。例如：张三，15999697713，广东省深圳市南山区科兴A1"
              :maxlength="100"
            ></el-input>
            <div class="clear-recognition-text" v-if="adderssFillingContent && adderssFillingContent.length >= 7" @click="adderssFillingContent = ''">
              清空
            </div>
            <div class="intelligent-recognition" v-if="adderssFillingContent && adderssFillingContent.length >= 7" @click="recognitionAddress">
              智能填写
            </div>
          </el-form-item>

          <el-form-item label="邮箱:" prop="email" label-width="76px">
            <el-input
              type="text"
              v-model.trim="addrModel.email"
              placeholder="此邮箱用于接收面试通知书、电子签证等重要信息"
              :maxlength="50"
            ></el-input>
          </el-form-item>

          <el-form-item v-if="type == 'add'" label-width="76px">
            <el-checkbox v-model="isNotSaveAddressStoreroom">
              仅该订单使用，不保存到地址簿
            </el-checkbox>
          </el-form-item>
        </el-form>
      </div>

      <div class="modal-footer">
        <el-button
          type="primary"
          size="large"
          @click="onFormSubmit"
          class="save-btn"
          >{{
            isNotSaveAddressStoreroom ? "确定使用" : "保存并使用"
          }}</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import utils from '../../../libs/utils';
import validates from '../../../libs/validates';
import pcdService from '../../../services/pcd-service';
import Http from '../../../libs/http';
import addressService from '../../../services/address-service';

export default {
  name: 'address-add-or-edit-modal',
  model: {
    prop: 'value',
    event: 'input',
  },
  props: {
    // 是否打开
    value: {
      type: Boolean,
      required: true,
      default: false,
    },
    // 传入的订单地址
    address: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      submitted: false, // 提交
      showModal: this.value, // 是否展示
      pcds: {},
      type: 'add', // 操作类型
      isNotSaveAddressStoreroom: false,
      adderssFillingContent: '', // 智能地址填写内容
      addrModel: {
        addressee: '', // 联系人
        mobile_phone: '', // 手机号
        email: '', // 邮箱
        province_code: '', // 省
        city_code: '', // 市
        county_code: '', // 区
        detail_address: '', // 详细地址
        is_default: 0, // 默认地址
      },
      rules: {
        // 验证
        addressee: [validates.required('姓名'), validates.range(15, 2, '姓名')],
        mobile_phone: [validates.required('电话'), validates.mobile('电话')],
        email: [validates.required('邮箱'), validates.email('邮箱')],
        detail_address: [validates.required('详细地址')],
      },
    };
  },
  computed: {
    // 地址是否合法
    pcdValid() {
      if (this.addrModel.city_code && this.pcds[this.addrModel.city_code]) {
        return (
          this.addrModel.province_code &&
          this.addrModel.city_code &&
          this.addrModel.county_code
        );
      }
      return this.addrModel.province_code && this.addrModel.city_code;
    },
  },
  methods: {
    // 初始化
    initModalData() {
      // 合并外部进来的数据
      this.addrModel = Object.assign({}, this.addrModel, this.address);

      // 如果没有区，后端会返回0，但是前端需要空字符串
      if (this.addrModel.county_code === 0) {
        this.addrModel.county_code = '';
      }

      // 根据ID判断添加还是编辑
      this.type = this.addrModel.peer_address_id ? 'edit' : 'add';

      // 如果是添加初始化要不要保存到地址库
      if (this.type === 'add') {
        const isNotSaveAddressStoreroom = Number(
          window.localStorage.getItem('isNotSaveAddressStoreroom'),
        );
        this.isNotSaveAddressStoreroom = Boolean(isNotSaveAddressStoreroom);
      }
    },

    // 关闭对话框
    onModalClose() {
      this.$emit('input', false);
      this.$refs.dataForm.resetFields();
      this.submitted = false;
    },

    // 重置地址数据
    resetData() {
      this.addrModel = {
        addressee: '',
        mobile_phone: '',
        email: '',
        province_code: '',
        city_code: '',
        county_code: '',
        detail_address: '',
        is_default: 0,
      };
    },

    // 识别地址
    recognitionAddress() {
      addressService
        .recognizeAddress(this.adderssFillingContent)
        .then((data) => {
          this.intelligentFillAddress(data);
          utils.msg.success('智能填写成功');
        })
        .catch((err) => {
          console.log(err);
          utils.msg.error(err.msg);
        });
    },

    // 处理特殊的区code
    parseCountyCode(addressParseData) {

      // 至少要识别到省和市才处理
      if (addressParseData.province_code && addressParseData.city_code) {
        const result = {
          province_code: +addressParseData.province_code,
          city_code: +addressParseData.city_code,
        };

        // 如果该地区有区
        if (this.pcds[addressParseData.city_code]) {

          // 如果识别到了区
          if (addressParseData.county_code) {
            result.county_code = +addressParseData.county_code;
            return result;
          }

          // 没有识别到区，就全部数据不要
          return {};
        }

        // 如果该地区没有有区
        result.county_code = '';
        return result;
      }

      // 没有识别到就直接返回空
      return {};
    },

    // 智能设置地址
    intelligentFillAddress(res) {

      const parsedPcdsData = this.parseCountyCode(res);

      // 要合并的地址原始对象
      const mergeAddress = {
        addressee: res.name ? res.name : this.addrModel.addressee,
        mobile_phone: res.mobile ? res.mobile : this.addrModel.mobile_phone,
        detail_address: res.detail ? res.detail.trim() : this.addrModel.detail_address,
      };

      // 如果有省才加入省字段
      if (parsedPcdsData.province_code) {
        mergeAddress.province_code = parsedPcdsData.province_code;
      }

      // 先设置其他属性
      this.addrModel = Object.assign({}, this.addrModel, mergeAddress);

      // 在设置别的属性
      if (parsedPcdsData.province_code) {

        // 依次设置地址省市区
        this.$nextTick()
          .then((vm) => {
            vm.addrModel.city_code = parsedPcdsData.city_code;
            return vm.$nextTick();
          })
          .then((vm) => {
            vm.addrModel.county_code = parsedPcdsData.county_code;
          });
      }
    },

    // 格式化表单数据
    formatFormData() {
      const postData = utils.extend(true, {}, this.addrModel);
      postData.province_code = +postData.province_code;
      postData.city_code = +postData.city_code;
      postData.county_code = Number(postData.county_code) || 0;
      return postData;
    },

    // 提交
    onFormSubmit() {
      this.submitted = true;

      this.$refs.dataForm.validate((valid) => {
        if (valid && this.pcdValid) {
          // 处理表单提交数据
          const postData = this.formatFormData();

          // 不是临时使用，就是要保存到地址库，就需要请求后台
          if (!this.isNotSaveAddressStoreroom) {
            this.saveAddressToBackend(postData);
          } else {
            // 如果是编辑来临时使用，则删除该ID
            if (this.type === 'edit') delete postData.peer_address_id;
            utils.msg.success('修改成功');
            this.handleAfterSubmit(postData);
          }
        }
      });
    },

    // 保存地址到后端
    saveAddressToBackend(postData) {
      const add = this.type === 'add';
      const url = add ? '/peer_address_add' : '/peer_address_update';
      const toastMsg = add ? '添加成功' : '修改成功';
      if (add) {
        window.localStorage.setItem(
          'isNotSaveAddressStoreroom',
          Number(this.isNotSaveAddressStoreroom),
        );
      }
      Http.post(url, postData)
        .then((data) => {
          utils.msg.success(toastMsg);
          if (this.type === 'add') {
            // 如果是添加地址，把返回的地址ID添加进去
            postData.peer_address_id = data.peer_address_id;
          }
          this.handleAfterSubmit(postData);
          this.submitted = false;
        })
        .catch((e) => {
          if (e) console.log(e);
        });
    },

    // 提交后的处理
    handleAfterSubmit(postData) {
      this.$emit('input', false);
      this.$emit('on-success', {
        type: this.type,
        address: postData,
        isNotSaveAddressStoreroom: this.isNotSaveAddressStoreroom,
      });
    },

    // 获取省市区数据
    getPcdData() {
      pcdService
        .getPcd()
        .then(pcds => (this.pcds = pcds))
        .catch((e) => {
          if (e) console.log(e);
        });
    },
  },
  watch: {
    // 同步显示
    value(newVal) {
      this.showModal = newVal;
    },

    // 同步显示
    showModal(newVal) {
      this.$emit('input', newVal);
    },
  },
  created() {
    this.getPcdData();
    this.initModalData();
  },
};
</script>

<style lang="less" scoped>
@import url("../../../assets/less/address-modal.less");
</style>



// WEBPACK FOOTER //
// src/pages/ordering/modals/address-add-or-edit-modal.vue